import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { RoutesKeys } from 'src/app/utils/routes';

@Injectable({
  providedIn: 'root',
})
/**
 * Rejects Create New Password route if no email is available
 */
export class CreateNewPasswordGuard implements CanActivate {
  /**
   * @constructor
   */
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  /**
   * Allows route to be accessed only if email is present
   * @return {boolean | Promise<boolean>}
   */
  canActivate(): Promise<boolean> | boolean {
    if (typeof this.authenticationService.passwordResetEmail === 'string') {
      return true;
    }
    return this.router.navigate([RoutesKeys.FORGOT_PASSWORD]);
  }
}
